import * as React from 'react';
import classnames from 'classnames';
import css from './required-mark.module.scss';

type Props = {
  className?: string;
};

const RequiredMark = ({ className }: Props) => {
  return <span className={classnames(css.requiredMark, className)}>*</span>;
};

export { RequiredMark };
export default RequiredMark;
